import PropTypes from 'prop-types'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'
import { useEffect } from 'react'
import { clearOnType } from '../../../../../../../utils/helpers/clearOnType.js'

export const Start = (props) => {
    // const allow = {
    //     hide: {
    //         geometria: props.wiz.form?.typ !== 'Opinia',
    //     },
    // }

    useEffect(() => {
        props.wiz.setForm(clearOnType(props.wiz.form, props.wiz.form?.typ))
        // eslint-disable-next-line
    }, [props.wiz.form?.typ])

    useEffect(() => {
        props.wiz.setValue('zalaczniki_list', [])
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {/*<JsonViewer src={props.wiz?.form || {}} show={true} />*/}

            <HeaderTitle noHr size={'fs-3'} title={'Start'} />

            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Wprowadź kluczowe informacje dotyczące projektu'}
            />


            <div className={'d-flex flex-column gap-3'}>
                <InputWiz wiz={props.wiz} keyName={'numer'} disabled={true} />
                <InputWiz wiz={props.wiz} keyName={'podmiot'} disabled={true} />
                <InputWiz wiz={props.wiz} keyName={'kategoria'} disabled={true} />
            </div>
        </>
    )
}

Start.propTypes = {
    wiz: PropTypes.any,
}
